import { render, staticRenderFns } from "./digitalocean.vue?vue&type=template&id=f10b318a&"
import script from "./digitalocean.vue?vue&type=script&lang=js&"
export * from "./digitalocean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports